export const defaultActionCellButtonCDSProps = {
  align: 'center',
  label: 'Action',
  width: '73px',
  customStyles: () => ({ paddingTop: 0, paddingBottom: 0 }),
};
